// Date-range preset dropdown.
//
// Covers the 90% of supervisor use cases (Today / Yesterday / Last 24h /
// Last 7d / Last 30d / This month). On select, computes the [from, to]
// in datetime-local ISO format (same shape Analytics' form state uses)
// and calls onPick(from, to).

import React from 'react';
import { Button, Menu } from '@mantine/core';
import { IconCalendar, IconChevronDown } from '@tabler/icons-react';
import { toDatetimeLocal } from '../utils';

const PRESETS = [
  { label: 'Today',       compute: () => rangeToday() },
  { label: 'Yesterday',   compute: () => rangeYesterday() },
  { label: 'Last 24h',    compute: () => rangeLastHours(24) },
  { label: 'Last 7 days', compute: () => rangeLastDays(7) },
  { label: 'Last 30 days', compute: () => rangeLastDays(30) },
  { label: 'This month',  compute: () => rangeThisMonth() },
];

export function DateRangePresets({ onPick, loading }) {
  return (
    <Menu shadow="md" width={160} position="bottom-end">
      <Menu.Target>
        <Button
          size="xs"
          variant="default"
          leftSection={<IconCalendar size={14} />}
          rightSection={<IconChevronDown size={12} />}
          disabled={loading}
        >
          Preset
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {PRESETS.map((p) => (
          <Menu.Item
            key={p.label}
            onClick={() => {
              const [from, to] = p.compute();
              onPick(toDatetimeLocal(from), toDatetimeLocal(to));
            }}
          >
            {p.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}

function rangeToday() {
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  return [start, new Date()];
}

function rangeYesterday() {
  const end = new Date();
  end.setHours(0, 0, 0, 0);
  const start = new Date(end.getTime() - 24 * 60 * 60 * 1000);
  return [start, end];
}

function rangeLastHours(hours) {
  const end = new Date();
  const start = new Date(end.getTime() - hours * 60 * 60 * 1000);
  return [start, end];
}

function rangeLastDays(days) {
  const end = new Date();
  const start = new Date(end.getTime() - days * 24 * 60 * 60 * 1000);
  return [start, end];
}

function rangeThisMonth() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
  return [start, now];
}
